import React from 'react';
import { Rifm } from 'rifm';
import Input2, { InputType, InputBackground } from '../input/Input2';
import { ThemeColors } from '../../themes/online';

const integerAccept = /\d+/g;

const parseInteger = (value: string) => (value.match(integerAccept) || []).join('');

const formatInteger = (value: string) => {
  const parsed = parseInteger(value);
  const number = Number.parseInt(parsed, 10);
  if (Number.isNaN(number)) {
    return '';
  }
  return `$ ${number.toLocaleString('en')}`;
};

export interface IMoenyInputProps {
  onChange: (value: string, name: string) => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  placeholder?: string;
  className?: string;
  centeredText?: boolean;
  dataAt: string;
  stretch?: boolean;
  width?: number | string;
  background?: InputBackground;
  disabled?: boolean;
  maxLength?: number;
  label?: string | React.ReactChild;
  error?: string;
  color?: ThemeColors;
}

// tslint:disable-next-line:variable-name
const MoneyInput = (props: IMoenyInputProps, ref: any) => {
  const [amount, setAmount] = React.useState('');
  const handleOnChange = React.useCallback(
    (newAmount: string) => {
      setAmount(newAmount);
      props.onChange(parseInteger(newAmount), props.name);
    },
    [props.onChange]
  );

  React.useEffect(() => {
    setAmount(props.value);
  }, []);

  return (
    <Rifm format={formatInteger} value={amount} onChange={handleOnChange}>
      {({ value, onChange }: { value: string; onChange: any }) => (
        <Input2
          placeholder="$  "
          {...props}
          innerRef={ref}
          type={InputType.Number}
          value={value}
          onChange={onChange}
          background={props.background}
          maxLength={props.maxLength}
          error={props.error}
          onKeyUp={props.onKeyUp}
        />
      )}
    </Rifm>
  );
};

export default React.forwardRef(MoneyInput);
